import React from 'react';
import styled from 'styled-components';

const StyledSubContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 20px auto;
  align-items: flex-start;

  @media (min-width: 768px) {
    margin: 0 auto;
  }
`;

const StyledResultList = styled.div`
  width: 100%;
`;

const StyledTile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-bottom: 40px;
  border-bottom: 1px solid var(--Primary-Stardust, #EAEAEA);
  margin-bottom: 30px;

  a {
    text-decoration: underline;
    font-size: 14px;

    @media (min-width: 1024px) {
      font-size: 16px;
    }
  }

  a:hover {
    text-decoration: underline;
  }
`;

const StyledCounter = styled.p`
  flex: 0 10%;
  color: var(--Primary-Void, #1A1B1B);
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  margin: 0;
  font-weight: 500;

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

const StyledMeta = styled.div`
  flex: 1;
`;

const StyledProfileName = styled.p`
  color: var(--Primary-Void, #1A1B1B);
  font-size: 14px;
  font-style: normal;
  text-transform: uppercase;
  line-height: 20px;
  margin: 0;
  font-weight: 500;

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

const StyledAddress = styled.p`
  color: var(--Primary-Void, #1A1B1B);
  font-size: 14px;
  font-style: normal;
  text-transform: uppercase;
  line-height: 24px;
  margin: 0;
  margin-top: 8px;

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

const StyledDistance = styled.p`
  color: var(--Primary-Void, #1A1B1B);
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  margin: 0;
  margin-top: 16px;

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

// TODO: This should be an a tag
const StyledPhone = styled.div`
  color: var(--Primary-Void, #1A1B1B);
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  text-decoration-line: underline;
  margin: 0;
  margin-top: 16px;
`;

const StyledDirections = styled.a`
  color: var(--Primary-Void, #1A1B1B);
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  text-decoration-line: underline;
  margin: 0;

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

const StyledInStock = styled.p`
            display: inline-block;
            width: auto;
            padding: 3px;
            font-size: 10px;
            font-weight: 900;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.45;
            letter-spacing: 0.5px;
            font-family: $futura_pt;
            text-transform: uppercase;
            color: #2ac278;
            border: 1px solid #2ac278;
`;

const StyledLogo = styled.div`
  flex: 0 10%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

interface Dealer {
  name: string;
  address: string;
  phone: string;
}

interface Result {
  dealer: Dealer;
  distance: number;
  status: string;
  inventoryDate: string;
}

interface ResultsListProps {
  results: Result[];
  data: { distanceUnit: string };
}

const ResultsList: React.FC<ResultsListProps> = ({ results, data }) => {

  const getDate = (date: string) => {
    let t = new Date(date);
    let dateString = monthNames[t.getMonth()] + ' ' + t.getDate();
    return dateString;
  };

  return (
    <StyledSubContainer>
      <StyledResultList>
        {results.map((result, index) => (
          <StyledTile key={index}>
            <StyledCounter>{index + 1}</StyledCounter>
            <StyledMeta>
              <StyledProfileName>{result.dealer.name}</StyledProfileName>
              <StyledAddress>{result.dealer.address}</StyledAddress>
              <StyledDistance>
                {result.distance.toFixed(2)} {data.distanceUnit === 'km' ? 'kilometers' : 'miles'}
              </StyledDistance>
              {result.inventoryDate !== null ? <StyledInStock>Verified In Stock: {getDate(result.inventoryDate)}</StyledInStock>
                      : null}
              <StyledPhone>
                <a href={`tel:${result.dealer.phone}`}>{result.dealer.phone}</a>
              </StyledPhone>
              <StyledDirections href={`https://maps.google.com?saddr=Current+Location&daddr=${result.dealer.address}`} target="_blank">
                Directions
              </StyledDirections>
            </StyledMeta>
            <StyledLogo>
              {result.status === "showcase_and_opted_in_TEST" ? (
                <img src="/on/demandware.static/Sites-Fender-Site/-/default/dw39698558/images/psd.png" alt={result.dealer.name} />
              ) : result.status === "showcase_and_opted_in_TESTTT" ? (
                <img src="/on/demandware.static/Sites-Fender-Site/-/default/dw1335f3ac/images/fad.png" alt={result.dealer.name} />
              ) : null}
            </StyledLogo>
          </StyledTile>
        ))}
      </StyledResultList>
    </StyledSubContainer>
  );
};

export default ResultsList;
